import * as React from 'react'

import { inject, observer } from 'mobx-react'
import { Path } from 'react-konva'

import MapViewItemBase from '~/client/src/shared/components/SitemapHelpers/models/MapViewItemBase'
import {
  CLOSED_BADGE_SPEC,
  HAS_CLOSURES_BADGE_SPEC,
} from '~/client/src/shared/map/markerGeometry'
import ClosuresStore from '~/client/src/shared/stores/domain/Closures.store'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'
import ThemeMode from '~/client/src/shared/utils/ThemeModeManager'

import KonvaLocationIcon from '../konvaElements/KonvaLocationIcon'
import { MAX_PERCENT } from '../KonvaSitemapItems'

import Colors from '~/client/src/shared/theme.module.scss'

interface IProps {
  item: MapViewItemBase
  containerWidth: number
  containerHeight: number

  closuresStore?: ClosuresStore
  projectDateStore?: ProjectDateStore

  selectedStartDate?: Date
  selectedEndDate?: Date
}

const CLOSED_ICON_OFFSET = 10
const HAS_CLOSURES_ICON_OFFSET_X = 0
const HAS_CLOSURES_ICON_OFFSET_Y = 16
const HAS_CLOSURES_ICON_SCALE = 0.1

@inject('closuresStore', 'projectDateStore')
@observer
export default class KonvaSitemapIcon extends React.Component<IProps & any> {
  public render() {
    const { containerWidth, containerHeight, item, bearing, ...rest } =
      this.props
    const {
      sitemapItemProperties: { iconProperties },
      color,
      iconName,
      isDisplayed,
    } = item
    if (!iconProperties || !iconProperties.isDisplayed || !isDisplayed) {
      return null
    }

    const x = (containerWidth * iconProperties.position.x) / MAX_PERCENT
    const y = (containerHeight * iconProperties.position.y) / MAX_PERCENT
    return (
      <>
        <KonvaLocationIcon
          color={color}
          x={x}
          y={y}
          type={iconName}
          isObjectClosed={this.isLocationClosed}
          rotation={bearing}
          {...rest}
        />
        {this.isLocationClosed && (
          <Path
            fill={ThemeMode.getHEXColor(Colors.error50)}
            scaleY={CLOSED_BADGE_SPEC.konvaScale}
            scaleX={CLOSED_BADGE_SPEC.konvaScale}
            x={x}
            y={y}
            offsetX={CLOSED_ICON_OFFSET}
            offsetY={CLOSED_ICON_OFFSET}
            data={CLOSED_BADGE_SPEC.path}
            rotation={bearing}
            isClosedIcon={true}
          />
        )}
        {this.isLocationHasClosures && (
          <>
            <Path
              fill="white"
              stroke="white"
              strokeWidth={1}
              x={x}
              y={y}
              offsetX={HAS_CLOSURES_ICON_OFFSET_X}
              offsetY={HAS_CLOSURES_ICON_OFFSET_Y}
              data={HAS_CLOSURES_BADGE_SPEC.path}
              rotation={bearing}
              scale={{
                x: HAS_CLOSURES_ICON_SCALE * 1.1,
                y: HAS_CLOSURES_ICON_SCALE * 1.1,
              }}
            />
            <Path
              fill={ThemeMode.getHEXColor(Colors.warning50)}
              x={x}
              y={y}
              offsetX={HAS_CLOSURES_ICON_OFFSET_X}
              offsetY={HAS_CLOSURES_ICON_OFFSET_Y}
              data={HAS_CLOSURES_BADGE_SPEC.path}
              rotation={bearing}
              scale={{ x: HAS_CLOSURES_ICON_SCALE, y: HAS_CLOSURES_ICON_SCALE }}
            />
          </>
        )}
      </>
    )
  }

  private get isCurrentDataWithinSelectedDateInterval(): boolean {
    const { projectDateStore, selectedStartDate, selectedEndDate } = this.props
    return projectDateStore.isWithinDateInterval(
      selectedStartDate,
      selectedEndDate,
      new Date(),
    )
  }

  private get isLocationHasClosures(): boolean {
    const {
      item: { dataObject },
      closuresStore,
      selectedStartDate,
      selectedEndDate,
    } = this.props

    return (
      dataObject &&
      closuresStore &&
      closuresStore.isLocationHasPartialClosuresWithinSelectedRange(
        dataObject.id,
        selectedStartDate,
        selectedEndDate,
      )
    )
  }

  private get isLocationClosed(): boolean {
    const {
      item: { dataObject },
      closuresStore,
      selectedStartDate,
      selectedEndDate,
    } = this.props

    return dataObject &&
      closuresStore &&
      this.isCurrentDataWithinSelectedDateInterval
      ? !closuresStore.isLocationNowOpen(dataObject.id)
      : closuresStore.isLocationClosedForEntirePeriod(
          dataObject.id,
          selectedStartDate,
          selectedEndDate,
        )
  }
}
